import { apiClient } from './client';

export type DemoRequestStatus =
    | 'new'
    | 'contacted'
    | 'booked'
    | 'completed'
    | 'no_show'
    | 'rejected';

export interface DemoRequestEmailLog {
    id: string;
    direction: 'outbound' | 'inbound';
    toAddress: string;
    fromAddress: string | null;
    subject: string;
    htmlPreview: string;
    status: 'sent' | 'failed';
    errorMessage: string | null;
    sentAt: string;
}

export interface DemoRequestSummary {
    id: string;
    name: string;
    email: string;
    company: string;
    role: string | null;
    teamSize: string | null;
    monthlyRevenue: string | null;
    channels: string[];
    preferredSlot: string | null;
    message: string | null;
    status: DemoRequestStatus;
    internalNotes: string | null;
    createdAt: string;
    updatedAt: string;
    emailCount?: number;
}

export interface DemoRequestDetail extends DemoRequestSummary {
    emails: DemoRequestEmailLog[];
}

export interface DemoRequestListResponse {
    items: DemoRequestSummary[];
    total: number;
}

export interface DemoRequestListQuery {
    status?: DemoRequestStatus | 'all';
    search?: string;
    limit?: number;
    offset?: number;
}

export const demoRequestsApi = {
    list: async (query: DemoRequestListQuery = {}): Promise<DemoRequestListResponse> => {
        const res = await apiClient.get('/admin/demo-requests', { params: query });
        return res.data.data;
    },

    get: async (id: string): Promise<DemoRequestDetail> => {
        const res = await apiClient.get(`/admin/demo-requests/${id}`);
        return res.data.data;
    },

    updateStatus: async (
        id: string,
        status: DemoRequestStatus,
        internalNotes?: string,
    ): Promise<DemoRequestSummary> => {
        const res = await apiClient.patch(`/admin/demo-requests/${id}/status`, {
            status,
            internalNotes,
        });
        return res.data.data;
    },
};
